<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <h2>{{ data.title }}</h2>
  <button mat-icon-button (click)="copyToClipboard()">
    <mat-icon>content_copy</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="tab-content">
    <app-editor
      [formControl]="jsonControl"
      [schema]="data.schema"
      [errors]="jsonControl.errors"
    ></app-editor>
  </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="end center">
  <button mat-button (click)="cancel()">Cancel</button>
  @if (!data.readonly) {
    <button mat-flat-button (click)="save()" [disabled]="jsonControl.invalid">
      <mat-icon>save</mat-icon>
      Apply Changes
    </button>
  }
</mat-dialog-actions>
